<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->

```vue
<template>
  <div class="min-h-screen bg-white">
    <!-- Header -->
    

    <!-- Hero Section -->
    <section class="relative pt-20">
      <div class="absolute inset-0">
        <img src="https://ai-public.mastergo.com/ai/img_res/011ec23c820ed337e28bdd3021f54d9c.jpg"
          class="object-cover object-top w-full h-full" alt="Luxury Real Estate" />
          <div class="absolute inset-0 bg-black bg-opacity-50"></div>
        <div class="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-transparent"></div>
      </div>

      <div class="container relative px-4 py-32 mx-auto">
        <div class="max-w-2xl text-white">
          <h1 class="mb-6 text-5xl font-bold">Smart Real Estate Investment Solutions</h1>
          <p class="mb-8 text-xl">Transform your financial future with strategic property investments. Access exclusive
            opportunities with returns up to 15% annually.</p>
          <button class="!rounded-button bg-white text-blue-900 px-8 py-3 text-lg font-semibold whitespace-nowrap">
            Explore Opportunities
          </button>
        </div>
      </div>
    </section>

    <!-- Benefits Section -->
    <section class="py-20 bg-gray-50">
      <div class="container px-4 mx-auto">
        <div class="grid gap-8 md:grid-cols-3">
          <div class="p-8 bg-white rounded-lg shadow-lg">
            <i class="mb-4 text-4xl text-blue-900 fas fa-chart-line"></i>
            <h3 class="mb-4 text-xl font-bold">Superior Returns</h3>
            <p class="text-gray-600">Average ROI of 12-15% annually through strategic property investments and market
              optimization.</p>
          </div>

          <div class="p-8 bg-white rounded-lg shadow-lg">
            <i class="mb-4 text-4xl text-blue-900 fas fa-shield-alt"></i>
            <h3 class="mb-4 text-xl font-bold">Secured Investment</h3>
            <p class="text-gray-600">Your investments are backed by real estate assets with comprehensive legal
              protection.</p>
          </div>

          <div class="p-8 bg-white rounded-lg shadow-lg">
            <i class="mb-4 text-4xl text-blue-900 fas fa-analytics"></i>
            <h3 class="mb-4 text-xl font-bold">Market Intelligence</h3>
            <p class="text-gray-600">Access to detailed market analysis and insights from industry experts.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Featured Properties -->
    <section class="py-20">
      <div class="container px-4 mx-auto">
        <h2 class="mb-12 text-3xl font-bold text-center">Featured Investment Properties</h2>
        <div class="grid gap-8 md:grid-cols-3">
          <div v-for="(property, index) in properties" :key="index" class="overflow-hidden bg-white rounded-lg shadow-lg">
            <img :src="property.image" class="object-cover object-top w-full h-64" :alt="property.title" />
            <div class="p-6">
              <h3 class="mb-2 text-xl font-bold">{{ property.title }}</h3>
              <p class="mb-4 text-gray-600">{{ property.location }}</p>
              <div class="flex justify-between mb-4">
                <span class="font-bold text-blue-900">${{ property.investment }}</span>
                <span class="text-green-600">{{ property.roi }}% ROI</span>
              </div>
              <p class="mb-4 text-gray-600">{{ property.description }}</p>
              <button class="!rounded-button w-full bg-blue-900 text-white py-2 whitespace-nowrap">Learn More</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Investment Process -->
    <section class="py-20 bg-gray-50">
      <div class="container px-4 mx-auto">
        <h2 class="mb-12 text-3xl font-bold text-center">How It Works</h2>
        <div class="grid gap-8 md:grid-cols-4">
          <div v-for="(step, index) in investmentSteps" :key="index" class="text-center">
            <div class="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-white rounded-full shadow-lg">
              <i :class="step.icon + ' text-2xl text-blue-900'"></i>
            </div>
            <h3 class="mb-2 text-xl font-bold">{{ step.title }}</h3>
            <p class="text-gray-600">{{ step.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Trust Indicators -->
    <section class="py-20">
      <div class="container px-4 mx-auto">
        <div class="grid gap-12 md:grid-cols-2">
          <div>
            <h2 class="mb-8 text-3xl font-bold">Why Choose Us</h2>
            <div class="grid grid-cols-2 gap-8">
              <div v-for="(stat, index) in statistics" :key="index">
                <div class="mb-2 text-3xl font-bold text-blue-900">{{ stat.value }}</div>
                <div class="text-gray-600">{{ stat.label }}</div>
              </div>
            </div>
          </div>

          <div>
            <div class="p-8 mb-8 bg-white rounded-lg shadow-lg">
              <i class="mb-4 text-2xl text-blue-900 fas fa-quote-left"></i>
              <p class="mb-4 text-gray-600">"RealtyWealth has transformed our investment portfolio. Their expertise and
                property selection are unmatched in the industry."</p>
              <div class="font-bold">Michael Anderson</div>
              <div class="text-gray-600">Chief Investment Officer, Anderson Capital</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Section -->
    

    <!-- Footer -->
    
  </div>
</template>

<script>
export default {
  name: 'InvestmentPage',
  data() {
    return {
      isMobileMenuOpen: false,
      properties: [
        {
          title: "Luxury Downtown Apartments",
          location: "Manhattan, New York",
          investment: "2,500,000",
          roi: "15",
          description: "Premium residential complex in the heart of Manhattan with guaranteed rental income.",
          image: "https://ai-public.mastergo.com/ai/img_res/3a487ad222e5be6fb504c5905e45e94b.jpg"
        },
        {
          title: "Commercial Plaza",
          location: "Chicago, Illinois",
          investment: "4,800,000",
          roi: "12",
          description: "Multi-tenant commercial property with long-term lease agreements in place.",
          image: "https://ai-public.mastergo.com/ai/img_res/28a904e14faf27953afb506e5bfcff2f.jpg"
        },
        {
          title: "Waterfront Development",
          location: "Miami, Florida",
          investment: "3,200,000",
          roi: "14",
          description: "Exclusive waterfront property development with high appreciation potential.",
          image: "https://ai-public.mastergo.com/ai/img_res/190543afafb5176e8709fc96c472b30f.jpg"
        }
      ],
      investmentSteps: [
        {
          icon: "fas fa-user-plus",
          title: "Create Account",
          description: "Sign up and complete your investor profile"
        },
        {
          icon: "fas fa-search",
          title: "Browse Properties",
          description: "Explore our curated investment opportunities"
        },
        {
          icon: "fas fa-file-signature",
          title: "Choose & Invest",
          description: "Select your investment and complete documentation"
        },
        {
          icon: "fas fa-chart-bar",
          title: "Track Returns",
          description: "Monitor your investment performance"
        }
      ],
      statistics: [
        {
          value: "$500M+",
          label: "Assets Under Management"
        },
        {
          value: "1,000+",
          label: "Active Investors"
        },
        {
          value: "15%",
          label: "Average Annual Returns"
        },
        {
          value: "50+",
          label: "Premium Properties"
        }
      ]
    };
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    }
  }
};
</script>

<style scoped>.custom-input::-webkit-outer-spin-button,
.custom-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}</style>

